"use client";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "./common/Button";
import InputField from "./common/InputField";

import { Bounce, ToastContainer } from 'react-toastify';
import { useUser } from "../context/UserContext";
import JWTService from '../services/JWTService';
import ToastService from '../services/ToastService';
import axiosInstance from './../api/axiosInstance';

const clientId = process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID;

const LoginForm = () => {

  const navigate = useNavigate();

  const { user, loginUser } = useUser(); // Use context

  useEffect(() => {
    if (user && !JWTService.isTokenExpired(user.token)) navigate("/app");

  })

  const onSuccess = async (response) => {
    try {
      const responseData = await axiosInstance.post("/auth/google", {
        clientId: response.clientId,
        credential: response.credential,
      });
      
      loginUser(responseData.data);

      ToastService.Success('🦄 Welcome !' + responseData.data.name)

      navigate("/app");

      // Lưu thông tin user hoặc JWT từ backend (nếu có)
    } catch (error) {
      console.error("Error sending token to backend:", error);
    }

  };

  const onFailure = (response) => {
    console.log('Login Failed:', response);
  };


  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleRegistrationRedirect = () => {
    // Navigate to login page using React Router
    navigate("/registration");
  };
  const handleForgotPasswordRedirect = () => {
    // Navigate to login page using React Router
    navigate("/forgot-password");
  };
  return (
    <form className="flex flex-col gap-6 items-start w-full">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      <div className="mb-4">
        <GoogleOAuthProvider clientId={clientId}>
          <GoogleLogin onSuccess={onSuccess} onError={onFailure} text='signin_with' />

        </GoogleOAuthProvider>
      </div>
      <div className="flex flex-col gap-4 items-start w-full">
        <InputField
          label="Username or e-mail address"
          placeholder="Enter your username or email address"
          type="text"
        />
        <div className="flex flex-col gap-2 items-end w-full">
          <InputField
            label="password"
            placeholder="Enter your password"
            type={showPassword ? "text" : "password"}
            icon={
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="cursor-pointer"
                onClick={togglePasswordVisibility}
              >
                <path
                  d="M12.1083 7.8916L7.8916 12.1083C7.34994 11.5666 7.0166 10.8249 7.0166 9.99993C7.0166 8.34993 8.34993 7.0166 9.99993 7.0166C10.8249 7.0166 11.5666 7.34994 12.1083 7.8916Z"
                  stroke="#384953"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M14.8499 4.8084C13.3915 3.7084 11.7249 3.1084 9.99987 3.1084C7.0582 3.1084 4.31654 4.84173 2.4082 7.84173C1.6582 9.01673 1.6582 10.9917 2.4082 12.1667C3.06654 13.2001 3.8332 14.0917 4.66654 14.8084"
                  stroke="#384953"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M7.0166 16.2751C7.9666 16.6751 8.97493 16.8917 9.99993 16.8917C12.9416 16.8917 15.6833 15.1584 17.5916 12.1584C18.3416 10.9834 18.3416 9.0084 17.5916 7.8334C17.3166 7.40006 17.0166 6.99173 16.7083 6.6084"
                  stroke="#384953"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M12.9252 10.5833C12.7085 11.7583 11.7502 12.7166 10.5752 12.9333"
                  stroke="#384953"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M7.8915 12.1084L1.6665 18.3334"
                  stroke="#384953"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M18.3334 1.66675L12.1084 7.89175"
                  stroke="#384953"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            }
          />
          <button
            type="button"
            className="text-sm leading-6 text-rose-700 border-b border-solid cursor-pointer border-b-rose-700"
            onClick={handleForgotPasswordRedirect}
          >
            Forgot Password?
          </button>
        </div>
      </div>
      <div className="flex flex-col gap-3 items-start w-full">
        <Button variant="disabled" size="large">
          Login
        </Button>
        <Button variant="outline" size="large" onClick={handleRegistrationRedirect}>
          Registration
        </Button>
      </div>
    </form>
  );
};

export default LoginForm;
